import { FormikContextType, useFormikContext } from 'formik';
import { UnsavedCourse } from '~/monolith-api';
import { StageEditor } from './StageEditor';

export function CourseStageEditorFormControl() {
   const { values: course, setFieldValue }: FormikContextType<UnsavedCourse> = useFormikContext();
   return (
      <StageEditor value={course.stages} onChange={stages => setFieldValue('stages', stages)} />
   );
}
